import { HttpHandler } from 'msw'

import { postCreationLink } from './postCreationLink'

import { getAllKonvives } from 'app/mocks/handlers/users/konvives/getAllKonvives'

export const usersKonvives: HttpHandler[] = [getAllKonvives, postCreationLink]
